// The payout schedule as the vendor reads it (aldoo-na store/payouts/schedule.js
// is the rule): a sale is due `holdDays` days after its day, and each payout,
// on `payoutDay` of the month, pays every sale due by then — so it covers a
// window of sale days. Days here are the browser's calendar days.

const day = (y, m, d) => new Date(Date.UTC(y, m, d))
const addDays = (date, days) => new Date(date.getTime() + days * 86400000)
const clampDay = (payoutDay) => Math.min(28, Math.max(1, Number(payoutDay) || 1))

/** The next payout day on or after today. */
export function nextPayoutDay(payoutDay, now = new Date()) {
  const today = day(now.getFullYear(), now.getMonth(), now.getDate())
  const thisMonth = day(now.getFullYear(), now.getMonth(), clampDay(payoutDay))
  if (thisMonth.getTime() >= today.getTime()) return thisMonth
  return day(now.getFullYear(), now.getMonth() + 1, clampDay(payoutDay))
}

/** The sale days a payout on `payDate` covers: { from, to }, both included. */
export function windowOf(payDate, { holdDays, payoutDay }) {
  const hold = Math.max(0, Number(holdDays) || 0)
  const previous = day(payDate.getUTCFullYear(), payDate.getUTCMonth() - 1, clampDay(payoutDay))
  return { from: addDays(previous, 1 - hold), to: addDays(payDate, -hold) }
}

const short = (date, locale) => date.toLocaleDateString(locale || "bg-BG", { day: "numeric", month: "long", timeZone: "UTC" })

/** The next payout and its window, as words: { pay, from, to }. */
export function nextWindow(terms, locale) {
  const pay = nextPayoutDay(terms.payoutDay)
  const { from, to } = windowOf(pay, terms)
  return { pay: short(pay, locale), from: short(from, locale), to: short(to, locale) }
}

/** When the vendor is paid, with the next payout's window of sales as the example (t: the portal's PAYOUTS texts). */
export function scheduleText(t, terms, locale) {
  const next = nextWindow(terms, locale)
  return t("Sales are paid on the %s of each month, once %s days have passed since the sale — e.g. on %s the sales of %s to %s are paid", terms.payoutDay, terms.holdDays, next.pay, next.from, next.to)
}
